import { ISetUp, TApplication } from '@dto'

class SessionService {
    private setup: ISetUp

     constructor(setup: ISetUp) { this.setup = setup }

    public has(key: TApplication): boolean {
        return key in sessionStorage
    }

    public get(key: TApplication): string {
        return sessionStorage.getItem(`${this.setup.acronym}mp_${key}`)
    }

    public getJson<T>(key: TApplication): T {
        const data = this.get(key)
        return data ? JSON.parse(atob(data)) : {}
    }

    public set(key: TApplication, value: string) {
        sessionStorage.setItem(`${this.setup.acronym}mp_${key}`, value)
    }

    public setJson(key: TApplication, value: any) {
        this.set(key, btoa(JSON.stringify(value)))
    }

    public remove(key: TApplication) {
        sessionStorage.removeItem(`${this.setup.acronym}mp_${key}`)
    }

    public clear() {
        sessionStorage.clear()
    }
}

export default SessionService
